import { useQuery } from 'react-query';
import fetchApi from 'services/fetch';

const useQueryWrapper = (keys, endpoint, params = null, callbacks = { success: null, error: null }, config = {}) => {
  const axiosObj = { method: 'GET', url: endpoint };
  if (params) {
    axiosObj.params = params;
  }
  return useQuery(
    keys,
    async () => {
      const { data } = await fetchApi({
        ...axiosObj,
      });
      return data;
    },
    {
      onSuccess: (data) => {
        if (callbacks.success) callbacks.success(data);
      },
      onError: (error) => {
        if (callbacks.error) callbacks.error(error);
      },
      enabled: false,
      refetchOnMount: false,
      retry: false,
      ...config,
    }
  );
};

export default useQueryWrapper;
